import { formateDate } from "context";
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  Spinner
} from "reactstrap";
import infoSport from "../../assets/img/custom/FHP_T_CONTEST.png";
import voteGetter from "../../assets/img/custom/vote-getter-img.jpg";
import { useDispatch, useSelector } from "react-redux";
import BrandAmbassadorWinnerModal from "components/modals/BrandAmbassadorWinnerModal";
import { toast } from "react-toastify";
import firebase from "../../config/firebase";
import {
  addContestEnrollment,
  getContestVideoData,
  getBrandAmbassodarContests,
  deleteContestEnrollment
} from "store/actions/contestAction";
import AddBrandAmbassadorVideoModal from "components/modals/AddBrandAmbassadorVideoModal";
import ReuseableTable from "components/Tables/ReuseableTable";

const BrandAmbassadorContestTab = ({
  activeTab,
  setBadgeType,
  setBrandAmbassadorId,
  toggleModal2,
  getVoteGetterBadgeQuantity,
  setWinnerQrCode,
  setBrandAmbassadorData
}) => {
  const dispatch = useDispatch();
  const { uid, user } = useSelector((state) => state.auth);
  const {
    brandAmbassodarContestData,
    brandAmbassodarContestLastDocument,
    brandAmbassodarContestHasMoreDocument
  } = useSelector((state) => state.contest);
  const [btnLoader, setBtnLoader] = useState(false);
  const [contestId, setContestId] = useState(null);
  const [infoModal, setInfoModal] = useState(false);
  const [dataLoader, setDataLoader] = useState(false);
  const [winnerModal, setWinnerModal] = useState(false);
  const [winnerData, constWinnerData] = useState("");
  const [enrolledIndex, setEnrolledIndex] = useState([]);
  const [contestEnrollmentId, setConteEnrollmentId] = useState([]);
  const [docId, setDocId] = useState(null);
  const [urls, setUrls] = useState([]);
  const [updateDocument, setUpdateDocument] = useState(false);
  const [contestVideoId, setContestVideoId] = useState(null);
  const [modal, setModal] = useState(false);
  const [getContestVideoLoader, setGetContestVideoLoader] = useState(false);
  const [loadMoreLoader, setLoadMoreLoader] = useState(false);
  const [athleteList, setAthleteList] = useState([
    {
      athleteId: user.athleteID,
      athleteName: user.first_name + " " + user.last_name,
      athlete_Id: uid
    }
  ]);

  const toggleWinnerModal = () => {
    setWinnerModal(!winnerModal);
  };
  const infoToggle = () => setInfoModal(!infoModal);

  const checkLeaderBoard = (data) => {
    constWinnerData(data);

    toggleWinnerModal();
  };

  const deleteContestEnrollments = (iD, contestDocId, enrolled, index) => {
    dispatch(
      deleteContestEnrollment(uid, iD, contestDocId, () => {
        toggleEnrollIndex(index);

        handleGetBrandAmbassodarContests(enrolled);
      })
    );
  };

  const handleGetBrandAmbassodarContests = (enrolled) => {
    dispatch(
      getBrandAmbassodarContests(uid, "", () => {
        setBtnLoader(false);
        if (!enrolled) {
          toast.success("Enrolled Sucessfully");
        } else {
          toast.success("Leave Sucessfully");
        }
      })
    );
  };

  const toggleEnrollIndex = (value) => {
    setEnrolledIndex((prevValues) => toggleEnrolledIndex(prevValues, value));
  };

  const toggleEnrolledIndex = (enrolledIndex, index) => {
    const indexPosition = enrolledIndex.indexOf(index);

    if (indexPosition === -1) {
      return [...enrolledIndex, index];
    } else {
      return enrolledIndex.filter((item) => item !== index);
    }
  };

  const handleAddContestEnrollment = (data, index, enrolled) => {
    dispatch(
      addContestEnrollment(data, (contestEnrollmentId) => {
        if (contestEnrollmentId) {
          let value = {
            index: index,
            contestEnrollmentId: contestEnrollmentId
          };
          toggleEnrollId(value);
        }
        handleGetBrandAmbassodarContests(enrolled);
        toggleEnrollIndex(index);
      })
    );
  };

  const toggleEnrollId = (value) => {
    setConteEnrollmentId((prevValues) =>
      toggleEnrollmentId(prevValues, value.index, value.contestEnrollmentId)
    );
  };

  const toggleEnrollmentId = (
    contestEnrollmentData,
    index,
    contestEnrollmentId
  ) => {
    const indexPosition = contestEnrollmentData.findIndex(
      (item) => item.index === index
    );

    if (indexPosition === -1) {
      return [
        ...contestEnrollmentData,
        { index: index, contestEnrollmentId: contestEnrollmentId }
      ];
    } else {
      return contestEnrollmentData.filter((item) => item.index !== index);
    }
  };

  const handleGetContestVideo = (iD) => {
    setGetContestVideoLoader(true);
    dispatch(
      getContestVideoData(iD, uid, (data) => {
        if (data != null) {
          setAthleteList(data.participantList);
          setUrls(data.videoUrl);
          setContestVideoId(data.id);
          setUpdateDocument(true);
        }
        setGetContestVideoLoader(false);
      })
    );
  };

  const toggleModal = () => {
    setModal(!modal);
    setUpdateDocument(false);
  };

  const handleLoadMore = () => {
    setLoadMoreLoader(true);
    dispatch(
      getBrandAmbassodarContests(
        uid,
        brandAmbassodarContestLastDocument,
        () => {
          setLoadMoreLoader(false);
        }
      )
    );
  };

  const columns = [
    "Start Date",
    "Buying End Date",
    "Your Status",
    "Contest Status",
    "Created At"
  ];

  const keyMap = {
    "Start Date": "startDate",
    "Buying End Date": "endDate",
    "Your Status": "yStatus",
    "Contest Status": "cStatus",
    "Created At": "createdAt"
  };

  const renderActions = (contest, index) => {
    return (
      <>
        {contest.status == "complete" ? (
          <Button
            size="sm"
            color="primary"
            className="text-nowrap mt-2 whitespace-nowrap"
            onClick={(e) => checkLeaderBoard(contest)}
          >
            See leaderBoard
          </Button>
        ) : contest.enrolled ? (
          <div className="whitespace-nowrap">
            <Button
              className="text-nowrap mt-2"
              id="block"
              size="sm"
              disabled={contest.contestEnrollmentStatus !== "Enrolled"}
              color="danger"
              onClick={(e) => {
                setContestId(contest.id);
                setBtnLoader(true);
                let contestDocId = null;
                if (contest?.contestEnrollmentId) {
                  contestDocId = contest?.contestEnrollmentId;
                } else {
                  let filteredIds = contestEnrollmentId.filter(
                    (item) => item.index === index
                  );
                  if (filteredIds.length > 0) {
                    contestDocId = filteredIds[0].contestEnrollmentId;
                  }
                }
                deleteContestEnrollments(
                  contest.id,
                  contestDocId,
                  contest?.enrolled,
                  index
                );
              }}
            >
              {contestId == contest.id && btnLoader ? (
                <Spinner size="sm" />
              ) : (
                "Leave"
              )}
            </Button>
            <Button
              className="text-nowrap mt-2"
              id="block"
              size="sm"
              disabled={contest.contestEnrollmentStatus !== "Enrolled"}
              color="primary"
              onClick={(e) => {
                let id = null;
                if (contest?.contestEnrollmentId) {
                  id = contest?.contestEnrollmentId;
                } else {
                  let filteredIds = contestEnrollmentId.filter(
                    (item) => item.index === index
                  );
                  if (filteredIds.length > 0) {
                    id = filteredIds[0].contestEnrollmentId;
                  }
                }
                setDocId(id);
                setUrls([]);
                setAthleteList([
                  {
                    athleteId: user.athleteID,
                    athleteName: user.first_name + " " + user.last_name,
                    athlete_Id: uid
                  }
                ]);

                setContestId(contest.id);
                handleGetContestVideo(contest.id);
                toggleModal();
              }}
            >
              Add Video
            </Button>
            <Button
              className="text-nowrap mt-2"
              id="block"
              size="sm"
              color="primary"
              onClick={() => {
                setWinnerQrCode("");
                setBadgeType("votegetter");
                setBrandAmbassadorId(contest?.id);
                toggleModal2();
                getVoteGetterBadgeQuantity(contest?.id);
                setBrandAmbassadorData(contest);
              }}
            >
              Create Badge
            </Button>
          </div>
        ) : (
          <Button
            className="text-nowrap mt-2"
            id="block"
            size="sm"
            color="primary"
            onClick={(e) => {
              setBtnLoader(true);
              setContestId(contest.id);
              let data = {
                athlete_id: uid,
                contest_id: contest.id,
                status: "Enrolled",
                createdAt: firebase.firestore.Timestamp.now()
              };
              handleAddContestEnrollment(data, index, contest?.enrolled);
            }}
          >
            {contestId == contest.id && btnLoader ? (
              <Spinner size="sm" />
            ) : (
              "Enroll"
            )}
          </Button>
        )}
      </>
    );
  };

  useEffect(() => {
    brandAmbassodarContestData &&
      brandAmbassodarContestData.length > 0 &&
      brandAmbassodarContestData.map((contest, index) => {
        if (contest.enrolled === true) {
          toggleEnrollIndex(index);
        }
      });
  }, [brandAmbassodarContestData]);

  useEffect(() => {
    setDataLoader(true);
    dispatch(
      getBrandAmbassodarContests(uid, "", () => {
        setDataLoader(false);
      })
    );
  }, []);
  return (
    <>
      <div>
        <Row>
          <Col lg="12" className="text-right">
            <b onClick={infoToggle} className="pointer ml-2">
              Vote Getter Info
            </b>
          </Col>
        </Row>
        {!dataLoader && (
          <ReuseableTable
            columns={columns}
            data={brandAmbassodarContestData?.map((contest) => ({
              ...contest,
              startDate: formateDate(contest.startDate),
              endDate: formateDate(contest.endDate),
              yStatus: contest.contestEnrollmentStatus
                ? contest.contestEnrollmentStatus
                : "pending",
              cStatus: contest.status,
              createdAt: formateDate(contest.createdAt)
            }))}
            keyMap={keyMap}
            renderActions={renderActions}
          />
        )}

        {dataLoader && (
          <div className="custom-table-body p-3 d-flex justify-content-center">
            <Spinner size={"md"} />
          </div>
        )}

        {!dataLoader && (
          <div className="w-100  p-3 d-flex justify-content-center">
            {brandAmbassodarContestData &&
              brandAmbassodarContestData?.length >= 5 && (
                <Button
                  color="primary"
                  onClick={handleLoadMore}
                  disabled={
                    !brandAmbassodarContestHasMoreDocument || loadMoreLoader
                  }
                >
                  {loadMoreLoader ? <Spinner size={"sm"} /> : "Load More"}
                </Button>
              )}
          </div>
        )}
        <Modal isOpen={infoModal} size="lg" toggle={infoToggle}>
          <ModalBody className="p-0">
            <img
              src={activeTab == "sportContest" ? infoSport : voteGetter}
              alt="Placeholder"
              className="w-100"
            />
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={infoToggle}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </div>

      <BrandAmbassadorWinnerModal
        winnerModal={winnerModal}
        toggleWinnerModal={toggleWinnerModal}
        winnerData={winnerData}
      />
      <AddBrandAmbassadorVideoModal
        modal={modal}
        toggleModal={toggleModal}
        athleteList={athleteList}
        setAthleteList={setAthleteList}
        contestVideoId={contestVideoId}
        contestId={contestId}
        docId={docId}
        urls={urls}
        getContestVideoLoader={getContestVideoLoader}
        setUrls={setUrls}
        setUpdateDocument={setUpdateDocument}
        updateDocument={updateDocument}
      />
    </>
  );
};

export default BrandAmbassadorContestTab;
